const getLicenseSortValue = (license) =>
  new Date(license?.updatedAt || license?.endsOn || license?.startsOn || 0).getTime();

export const getCurrentLicense = (data) => {
  if (Array.isArray(data)) {
    if (data.length === 0) return null;
    return [...data].sort(
      (left, right) => getLicenseSortValue(right) - getLicenseSortValue(left),
    )[0];
  }
  return data || null;
};

export const computeIsExpired = (license) => {
  if (!license) return false;

  if (typeof license.isExpired === "boolean") {
    return license.isExpired;
  }

  if (!license.endsOn) return false;

  const endsOn = new Date(license.endsOn);
  if (Number.isNaN(endsOn.getTime())) return false;

  const graceDays = Number(license.graceDays || 0);
  const graceSafe = Number.isNaN(graceDays) ? 0 : Math.max(0, graceDays);
  endsOn.setDate(endsOn.getDate() + graceSafe);
  return Date.now() > endsOn.getTime();
};

export const hasActiveLicense = (data) => {
  const currentLicense = getCurrentLicense(data);
  if (!currentLicense) return false;
  if (
    typeof currentLicense === "object" &&
    !Array.isArray(currentLicense) &&
    Object.keys(currentLicense).length === 0
  ) {
    return false;
  }

  const status = String(currentLicense.status || "").trim().toUpperCase();
  if (status && status !== "ACTIVE") {
    return false;
  }

  return !computeIsExpired(currentLicense);
};
